export const CartSkuB = () => <>CartSkuB</>;
